import { render, staticRenderFns } from "./ReferencesModal.vue?vue&type=template&id=2e9dfdc8&"
import script from "./ReferencesModal.vue?vue&type=script&lang=js&"
export * from "./ReferencesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports